var _mask, _rect, _mask2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 20,
    height: 6,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 20,
    height: 6,
    rx: 1,
    stroke: "#434443",
    strokeWidth: 4,
    mask: "url(#a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 14a8 8 0 1 1 16 0v1.901a.099.099 0 0 1-.099.099H6.099A.099.099 0 0 1 6 15.901V14Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14a8 8 0 1 1 16 0v1.901a.099.099 0 0 1-.099.099H6.099A.099.099 0 0 1 6 15.901V14Z",
    stroke: "#434443",
    strokeWidth: 4,
    mask: "url(#b)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHead);
export default __webpack_public_path__ + "static/media/icon-head.980565054158db994cfbdeceb7304173.svg";
export { ForwardRef as ReactComponent };